import React from 'react'
import { makeStyles } from 'tss-react/mui';
import { Box, Pagination, Typography, useTheme } from '@mui/material'

const useStyles = makeStyles()((theme) => {
    return {
        pagination: {
            "& .MuiPagination-ul": {
                gap: "10px"
            },
            "& .MuiPaginationItem-root": {
                backgroundColor: "white",
                border: '1px solid #99999945',
                borderRadius: '6px',
                color: "black",
                fontSize: "14px",
                margin: '0px',
                padding: '0px',
                alignContent: "center",
                minHeight: "34px",
                minWidth: "34px",
                "&:hover": {
                    backgroundColor: theme.palette.grey[200],
                },
                "&.Mui-selected": {
                    backgroundColor: theme.palette.primary.main,
                    border: 'none',
                    color: "white",
                },
            },
            "& .MuiPaginationItem-previousNext": {
                borderRadius: '50%',
                backgroundColor: "white",
                border: '1px solid #999999',
                color: "black",
                "&:hover": {
                    backgroundColor: theme.palette.grey[200],
                },
            },
        },
    };
});


const CommonPagination = ({ page, onChange, count, size, mt, itemsPerPage, totalCount }) => {
    const theme = useTheme();
    const { classes } = useStyles();

    // Calculate start and end indices
    const startIndex = (page - 1) * itemsPerPage + 1;
    const endIndex = Math.min(page * itemsPerPage);
    let showEndIndex = endIndex < totalCount ? endIndex : totalCount

    return (
        <Box display={'flex'} justifyContent={'space-between'} alignItems={"center"} mt={mt ? mt : 0} padding={"25px"}>
            <Typography fontSize={"18px"} fontFamily={"Satoshi-Medium"} color={theme.palette.bgBlack.main}>
                {`Showing ${startIndex}-${showEndIndex} of ${totalCount} records`}
            </Typography>
            <Pagination
                count={count}
                size={size ? size : "small"}
                page={page}
                onChange={onChange}
                className={classes.pagination}
            />
        </Box>
    );
};

export default CommonPagination;